import { omit } from '@ricoh/ria.client.core/utils/data/object';

import type { ClassificationOptions } from '~/common/model/api/separation-profile';

import type { TransformClassificationOptions } from './_classification.type';

/**
 * Transform ClassificationOptions.
 *
 * @param {ClassificationOptions} options ClassificationOptions.
 *
 * @returns {TransformClassificationOptions} Transformed ClassificationOptions.
 */
export function transformClassificationOptions(options: ClassificationOptions): TransformClassificationOptions {
  return {
    classification: options.$is,
    ...omit(options, '$is'),
  } as TransformClassificationOptions;
}

/**
 * Prepare ClassificationOptions.
 *
 * @param {TransformClassificationOptions} options Transform ClassificationOptions.
 *
 * @returns {ClassificationOptions} ClassificationOptions.
 */
export function prepareClassificationOptions(options: TransformClassificationOptions): ClassificationOptions {
  return {
    $is: options.classification,
    ...omit(options, 'classification'),
  } as ClassificationOptions;
}
